import { Injectable } from '@angular/core'
import { Select, State, Action, StateContext, Selector, NgxsOnInit, Store, NgxsSimpleChange } from '@ngxs/store'
import { Observable } from 'rxjs';
import { UserState } from 'src/app/state-man/state/user.state';
import { User } from 'src/app/state-man/models/user.model';
import { UnitActions } from '../actions/unit.actions';
import { Unit } from '../models/unit.model';
import { UnitService } from 'src/app/services/unit.service';
import { StorageService } from 'src/app/services/storage.service';

export class UnitStateModel {
    is_refreshing: boolean
    unit: Unit[]
}

@State<UnitStateModel>({
    name: 'unit',
    defaults: {
        is_refreshing: true,
        unit: []
    }
})
@Injectable()
export class UnitState implements NgxsOnInit {
    @Select(UserState.getUser) user$: Observable<User>

    constructor(        
        private unitService: UnitService,
        private store: Store,
        private storageService: StorageService
    ) {}

    async ngxsOnInit(ctx: StateContext<UnitStateModel>) {                
        this.user$.subscribe(async (user: User) => {            
            if (user.is_logged_in) {     
                this.storageService.events.subscribe(async (status: any) => {
                    if (this.storageService.is_initialized) {
                        await this.reloadStateFromStorage()                        
                    }
                })                           
            }
        }) 
    }

    async ngxsOnChanges(change: NgxsSimpleChange) {          
        if (this.storageService.is_initialized) {
            const state_model: UnitStateModel = change.currentValue
            this.storageService.set('units', JSON.stringify(state_model))    
        }    
    }

    async reloadStateFromStorage() {        
        const json = await this.storageService.get('units');        
        if (json) {
            const state_model: UnitStateModel = JSON.parse(json)
            if (state_model) {
                this.store.dispatch(new UnitActions.Init(state_model));
                return
            }
        }
        this.store.dispatch(new UnitActions.Refresh())
    }

    async reloadStateFromApi() : Promise<boolean> {    
        const objs = await this.unitService.getAll()    
        if (objs != null) {
          const many = Unit.buildMany(objs)                  
          this.store.dispatch(new UnitActions.Set(many))
          return true
        }
        return false
    }
  
    @Selector()
    static getState(state: UnitStateModel) {
        return state
    }

    @Selector()
    static getIsRefreshing(state: UnitStateModel) {
        return state.is_refreshing
    }

    @Selector()
    static getAll(state: UnitStateModel) {
        return state.unit
    }

    @Action(UnitActions.Refresh)
    async refresh({patchState}: StateContext<UnitStateModel>, {  }:UnitActions.Refresh) {
        patchState({is_refreshing: true})
        if (!await this.reloadStateFromApi()) {            
            patchState({is_refreshing: false})
        }
    }

    @Action(UnitActions.Init)
    init({setState, getState}: StateContext<UnitStateModel>, { payload }:UnitActions.Init) {                  
        const state = getState()
        payload.is_refreshing = state.is_refreshing
        setState(payload)
        this.store.dispatch(new UnitActions.Refresh())
    }
    
    @Action(UnitActions.Set)
    set({setState}: StateContext<UnitStateModel>, { payload }:UnitActions.Set) {             
        setState({      
            is_refreshing: false,      
            unit: payload
        })
    }
}
